import { createApi } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../../utils';
import { Firm, Project, ProjectStatusCount, UserResponse } from '../types';
import { baseQueryWithAuthCheck } from './base-queries';

export type GetProjectResponse = {
  projects: Project[];
  unique_project_types: string[];
  firm: Firm;
  user: UserResponse;
  total_quarter_awarded: string;
  total_year_awarded: string;
  total_fee: string;
  status_count: ProjectStatusCount;
};

export type ProjectNumberPayload = {
  project_number_old: number;
  project_number_new: number;
};

const baseUrl = getApiUrl('projects');

// Define a service using a base URL and expected endpoints
export const projects = createApi({
  reducerPath: 'projectsApi',
  tagTypes: ['Projects'],
  // baseQuery: fetchBaseQuery({
  //   baseUrl,
  //   prepareHeaders: (headers, api) => {
  //     headers.set('x-api-key', process.env.REACT_APP_X_API_KEY)
  //     // headers.set('Content-Type', 'application/json')

  //     return headers
  //   },
  //   credentials: 'include',
  //   mode: 'cors'
  // }),
  baseQuery: baseQueryWithAuthCheck(baseUrl),
  endpoints: ({ query, mutation }) => ({
    getAllProjects: query<GetProjectResponse, { status: Project['status'] }>({
      // getAllProjects: query<GetProjectResponse, { fiscal_year?: number; quarter?: number }>({
      query: ({ status }) => {
        // query: ({ fiscal_year, quarter }) => {
        // return `/${fiscal_year ? `?fiscal_year=${fiscal_year}&` : quarter ? '?' : ''}${quarter ? `quarter=${quarter}` : ''}`
        return `&status=${status ?? 'ALL'}`;
      },
      providesTags: ['Projects'],
      // providesTags: (result) => {
      //   return result ? result.projects.map((project) => ({ type: 'Projects', id: project.id })) : ['Projects']
      // },
    }),
    getProjectById: query<Project, number>({
      query: (projectId) => {
        return `/get_latest_single_project/${projectId}`;
      },
      providesTags: (result, error, id) => {
        return [{ type: 'Projects', id }, 'Projects'];
      },
    }),
    addProject: mutation<Project, Partial<Project>>({
      query: (newProject) => {
        return {
          url: '/',
          method: 'POST',
          body: newProject,
        };
      },
      invalidatesTags: ['Projects'],
    }),
    updateProject: mutation<Project, Partial<Project>>({
      // TODO: id vs project_number
      query: (updatedProject) => {
        return {
          url: `${updatedProject.id}`,
          method: 'PATCH',
          body: updatedProject,
        };
      },
      invalidatesTags: ['Projects'],
      // invalidatesTags: (result, error, { id }) => [{ type: 'Projects', id }],
    }),
    updateProjectNumber: mutation<
      { project_number_new: number },
      ProjectNumberPayload
    >({
      query: ({
        project_number_old,
        project_number_new,
      }: ProjectNumberPayload) => {
        return {
          url: `/update_project_number`,
          method: 'PATCH',
          body: {
            project: {
              project_number_new,
              project_number_old,
            },
          },
        };
      },
      invalidatesTags: ['Projects'],
    }),
    deleteProject: mutation<undefined, number>({
      query: (project_number) => ({
        url: '/delete',
        method: 'DELETE',
        body: { project_number },
      }),
      invalidatesTags: ['Projects'],
    }),
    uploadCsv: mutation<{ success: boolean }, string>({
      query: () => ({
        url: '/upload_csv',
        method: 'POST',
      }),
      invalidatesTags: ['Projects'],
    }),
  }),
});

// TODO: https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllProjectsQuery,
  useLazyGetProjectByIdQuery,
  useAddProjectMutation,
  useUpdateProjectMutation,
  useUploadCsvMutation,
  useDeleteProjectMutation,
  useUpdateProjectNumberMutation,
} = projects;
export const projectsApi = projects.endpoints;
export const resetProjectsApi = () => {
  projects.util.resetApiState();
};
